<a href="#main-content" class="skip-link">Skip to main content</a>
<p-toast key="clinic" position="top-right" styleClass="clinic-toast" />
<div id="main-content">
  <router-outlet />
  <app-hotkey-help *ngIf="showGlobalHotkeyHelp" />
</div>
